// face_emotion_detection Redux actions
// Action types
export const SET_FACE_EMOTION_DETECTION_VISIBLE = 'SET_FACE_EMOTION_DETECTION_VISIBLE';
export const SET_FACE_EMOTION_DETECTION_ENABLED = 'SET_FACE_EMOTION_DETECTION_ENABLED';
export const SET_FACE_EMOTION_DETECTION_DETECTING = 'SET_FACE_EMOTION_DETECTION_DETECTING';
export const SET_CURRENT_FACE_DATA = 'SET_CURRENT_FACE_DATA';
export const SET_FACE_EMOTION_DETECTION_ERROR = 'SET_FACE_EMOTION_DETECTION_ERROR';
// Action creators
export function setFaceEmotionDetectionVisible(visible) {
    return {
        type: SET_FACE_EMOTION_DETECTION_VISIBLE,
        visible
    };
}
export function setFaceEmotionDetectionEnabled(enabled) {
    return {
        type: SET_FACE_EMOTION_DETECTION_ENABLED,
        enabled
    };
}
export function setFaceEmotionDetectionDetecting(detecting) {
    return {
        type: SET_FACE_EMOTION_DETECTION_DETECTING,
        detecting
    };
}
export function setCurrentFaceData(faceData) {
    return {
        type: SET_CURRENT_FACE_DATA,
        faceData
    };
}
export function setFaceEmotionDetectionError(error) {
    return {
        type: SET_FACE_EMOTION_DETECTION_ERROR,
        error
    };
}
